// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5528":"48f20d3b","5584":"77ab36e7"}[chunkId] + ".chunk.css";
};